import MovieFilterRoundedIcon from '@mui/icons-material/MovieFilterRounded';
import PostRail from '../shared/PostRail';
import { SectionCard } from '../shared/insightUi';

export default function TopReels({ top_reels = [] }) {
  const posts = (Array.isArray(top_reels) ? top_reels : []).slice(0, 30);
  if (!posts.length) return null;
  return (
    <SectionCard
      icon={<MovieFilterRoundedIcon fontSize="small" />}
      title="Top reels"
      subtitle="Best performing reels by engagement"
      bodyPadding="16px 24px 12px"
    >
      <PostRail posts={posts} />
    </SectionCard>
  );
}
